<div class="logo"
[class.na]="!company"
[title]="company?.name ? company.name : ''">
  <div
  [style.backgroundImage]="company?.logo ? (company.logo|trustStyleUrl) : ''"></div>
</div>